import { render, staticRenderFns } from "./AnalysisGroupDetail.vue?vue&type=template&id=0b37fc0e&scoped=true"
import script from "./AnalysisGroupDetail.vue?vue&type=script&lang=js"
export * from "./AnalysisGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./AnalysisGroupDetail.vue?vue&type=style&index=0&id=0b37fc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37fc0e",
  null
  
)

export default component.exports